'use client'
import { useContext, useState } from 'react'
import { useTranslations, useFormatter } from 'next-intl'

import { Link } from '@/i18n/navigation'

import { ButtonLabel, Heading, Paragraph } from '@/components/atoms/Typography'
import { Modal } from '@/components/atoms/Modal'
import Button from '@/components/atoms/Button'
import Flex from '@/components/atoms/Flex'
import Icon from '@/components/atoms/Icon'

import styles from './NotActiveCompetition.module.scss'
import {
  PublicCompetitionContext,
  PublicCompetitionContextType,
} from '@/contexts/PublicCompetitionContext'

const NotActiveCompetition = ({
  autoWidth = true,
}: {
  autoWidth?: boolean
}) => {
  const format = useFormatter()
  const t = useTranslations('General')
  const { data } = useContext(
    PublicCompetitionContext
  ) as PublicCompetitionContextType

  const [isOpen, setIsOpen] = useState(false)

  if (!data?.resource) return null

  const { title, resource } = data
  const { end_date } = resource as { end_date: string }
  const productType =
    (data.type as 'competition' | 'application') || 'competition'
  const buttonKey =
    productType === 'application'
      ? 'notActive.button_application'
      : 'notActive.button_competition'
  const modalTitleKey =
    productType === 'application'
      ? 'notActive.modalTitle_application'
      : 'notActive.modalTitle_competition'

  const competitionTitle = title as string

  return (
    <>
      <Button
        className={styles.button}
        theme='gray'
        autoWidth={autoWidth}
        onClick={() => setIsOpen(true)}
      >
        <ButtonLabel
          size='md'
          weight='semi-bold'
        >
          {t(buttonKey)}
        </ButtonLabel>
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Flex
          direction='column'
          gap='1rem'
        >
          <div className={styles.iconContainer}>
            <Icon
              iconName={'AlertTriangle'}
              width={56}
              height={56}
              aria-label={t(buttonKey)}
            />
          </div>
          <Heading
            size='md'
            weight='bold'
          >
            {t(modalTitleKey)}
          </Heading>
          <Paragraph
            size='md'
            content={t('notActive.modalText', {
              competitionName: competitionTitle,
              deadlineDate: format.dateTime(new Date(end_date), 'deadline'),
            })}
            dangerouslySetInnerHTML
          />
          <Button
            as={Link}
            variant='primary'
            href='/'
            Icon={() => <Icon iconName='ArrowRight' />}
            onClick={() => setIsOpen(false)}
          >
            {t('notActive.modalButton')}
          </Button>
        </Flex>
      </Modal>
    </>
  )
}

export default NotActiveCompetition
